import { render, staticRenderFns } from "./dangyuan.vue?vue&type=template&id=ae50c308&scoped=true&"
import script from "./dangyuan.vue?vue&type=script&lang=js&"
export * from "./dangyuan.vue?vue&type=script&lang=js&"
import style0 from "./dangyuan.vue?vue&type=style&index=0&id=ae50c308&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae50c308",
  null
  
)

export default component.exports